export default "__VITE_ASSET__6a0a533a__"